import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { FormTitle, Text, SelectField } from "ui-components/Form";

const uomTypeOpt = ["BASE", "INNERPACK", "CASE", "PALLET"];
function SKURetailBarcodeDetail({ detailRender, control, errors, newItem, active }) {
  return (
    <MDBox>
      <FormTitle title="SKU Retail Barcode Details" />
      <MDBox mt={1.625}>
        {detailRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((property, index) => {
              const { edit, xs, ...data } = property;
              const xs2 = xs ? xs : 12 / rows.length;
              const fieldProps = {
                ...data,
                control,
                errors,
                ...(data.name === "retailBarcode" && newItem === false && { disabled: true }),
                ...(active === false && { disabled: true,type:"text" }),
              };
              let renderField;
              if (fieldProps.type === "text") {
                renderField = <Text field={fieldProps} />;
              } else if (data.type === "select") {
                renderField = <SelectField field={fieldProps} options={uomTypeOpt} />;
              }
              return (
                <Grid item xs={xs2} key={index}>
                  {renderField}
                </Grid>
              );
            })}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default SKURetailBarcodeDetail;
